// NOTE: remember to update the UI-texts file on the drive, if you update this file */
const loginUiTexts = {
	start: {
		da: 'Start',
		en: 'Start',
	},
	login: {
		da: 'Log ind',
		en: 'Log in',
	},
	logout: {
		da: 'Log ud',
		en: 'Log out',
	},
	player: {
		da: 'Spiller',
		en: 'Player',
	},
	facilitator: {
		da: 'Facilitator',
		en: 'Facilitator',
	},
	admin: {
		da: 'Administrator',
		en: 'Administrator',
	},
	email: {
		da: 'e-mail',
		en: 'e-mail',
	},
	password: {
		da: 'password',
		en: 'password',
	},
	passwordRepeat: {
		da: 'gentag password',
		en: 'repeat password',
	},
	userId: {
		da: 'medarbejder-nr.',
		en: 'employee no.',
	},
	name: {
		da: 'navn',
		en: 'name',
	},
	loginWithUserId: {
		da: 'Log ind med medarbejder-nr.',
		en: 'Log in with employee no.',
	},
	createNewUser: {
		da: 'Opret ny bruger',
		en: 'Create new user',
	},
	forgotPassword: {
		da: 'Glemt dit password?',
		en: 'Forgot your password?',
	},
	resetPassword: {
		da: 'Nulstil password',
		en: 'Reset tpassword',
	},
	goToLoginBtn: {
		da: 'Tilbage til login',
		en: 'Back to login',
	},
	createUserBtn: {
		da: 'Opret',
		en: 'Create',
	},
	reset: {
		da: 'Nulstil',
		en: 'Reset',
	},
	cancel: {
		da: 'Afbryd',
		en: 'Cancel',
	},
	cancel2: {
		da: 'Annuller',
		en: 'Cancel',
	},
	createUserFeedback: {
		da: 'Din bruger er blevet oprettet. Gå tilbage og log ind for at spille.',
		en: 'Your new user has been created. Go back to log in to play.',
	},
	passwordResetFeedback: {
		da: 'Du har modtaget et link til at nulstille dit password i din indbakke.',
		en: 'You have received a link to reset your password in your inbox.',
	}
};




module.exports = {
	loginUiTexts
};